import Header from "@components/common/Header";
import { NavLink } from "react-router-dom";
import "./open-details.scss";
import Comments from "@components/Support/OpenDetails/Comments/comments-section";
import OldComments from "@components/Support/OpenDetails/ExistingComments/old-comments";
import { useParams } from "react-router-dom";
import { getValue } from "@utils/lodash";
import InputField from "@_common/InputRuleFeild";
import { useEffect, useRef, useState } from "react";
import {
  deleteSupportTicket,
  getSpecificSupportTicket,
  updateSupportTicket,
  uploadSupportTicket,
} from "@services/support.service";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  convertCurrentDate,
  convertCurrentDateWithTime,
} from "@_common/date-helpers";
import { QueryRequestHelper } from "@_common/query-request-helper";
import {
  addTaskComments,
  deleteTaskComments,
  getTaskComments,
  updateTaskComments,
} from "@services/comments.service";
import DeleteModal from "@_common/deleteModal";
import { handleDownloadOnClick } from "@_common/downloadfile";
import CustomFileUpload from "@_common/custom-file-upload";
import { clientFileUploads } from "@services/client-list.service";
import NoAccessPage from "@components/common/NoAccess";
import { useLocation } from "react-router-dom";
import { sanitizeInput } from "@_common/dompurify";

export default function OpenDetails(props: any) {
  const mainParams = useParams();
  const navigate = useNavigate();
  let route = window.location.pathname.split("/");
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);

  const [info, setInfo] = useState({});
  const [request, setRequest] = useState({
    module: "REPORTS",
    severity: "HIGH",
    ticket_title: "",
    description: "",
    support_status: "",
  });
  // OPEN, IN_PROGRESS, CLOSED
  const [supportStatus] = useState([
    { value: "OPEN", label: "Open" },
    { value: "IN_PROGRESS", label: "In Progress" },
    { value: "CLOSED", label: "Closed" },
  ]);
  const [module] = useState([
    { value: "REPORTS", label: "Reports" },
    { value: "VENDOR", label: "Vendor" },
    { value: "PE_COMPLIANCE", label: "PE Compliance" },
    { value: "SELF_COMPLIANCE", label: "Self Compliance" },
    { value: "LICENSE", label: "License" },
    { value: "LOGIN", label: "Login" },
    { value: "BUG", label: "Bug" },
    { value: "OTHER", label: "Other" },
  ]);

  const [severity] = useState([
    { value: "HIGH", label: "High" },
    { value: "MEDIUM", label: "Medium" },
    { value: "LOW", label: "Low" },
  ]);

  const handleChangeRequest = (e: any) => {
    const { name, value } = e.target;
    setRequest({
      ...request,
      [name]: sanitizeInput(value),
    });
  };

  const handleChangeSelect = (e: any, name: string) => {
    setRequest({
      ...request,
      [name]: e.value,
    });
  };
  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    getData();
  }, []);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = useState(true);
  const [accessError, setAcceessError] = useState<any>("");
  const getData = async () => {
    try {
      setIsLoading(true);
      let resp = await getSpecificSupportTicket(getValue(mainParams, `id`, ""));
      if (resp) {
        setInfo(getValue(resp, `data`, {}));
        setRequest({
          ...request,
          module: getValue(resp, `data.module`, ""),
          severity: getValue(resp, `data.severity`, ""),
          ticket_title: getValue(resp, `data.ticket_title`, ""),
          description: getValue(resp, `data.description`, ""),
          support_status: getValue(resp, `data.support_status`, ""),
        });
        setUploadedDocuments(getValue(resp, `data.documents`, []));
        setIsLoading(false);
        getComments();
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setAcceessError(error);
      setIsLoading(false);
    }
  };

  let [submitLoading, setSubmitLoading] = useState(false);
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      try {
        let payload = request;
        setSubmitLoading(true);
        let resp = await updateSupportTicket(
          getValue(mainParams, `id`, ""),
          payload
        );
        if (resp) {
          setSubmitLoading(false);
          toast.success(getValue(resp, `message`, ""));
          // navigate(`/support/${getValue(mainParams, `main_route`, "")}`);
          navigate(`/support/${route[2]}`);
        } else {
          setSubmitLoading(false);
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                          Comments Section                                  */
  /* -------------------------------------------------------------------------- */
  const [commentLoading, setCommentLoading] = useState(false);
  const [allComments, setAllComments] = useState([]);
  const getComments = async () => {
    try {
      let payload = {
        type: "SUPPORT_COMMENT",
        support_id: getValue(mainParams, `id`, ""),
      };
      let queryRequest = QueryRequestHelper(payload);
      setCommentLoading(true);
      let resp = await getTaskComments(queryRequest);
      if (resp) {
        setCommentLoading(false);
        setAllComments(getValue(resp, `data.comments`, []));
      } else {
        setCommentLoading(false);
      }
    } catch (error) {
      setCommentLoading(false);
    }
  };
  const [commentRequest, setCommentRequest] = useState({
    comments: "",
    type: "SUPPORT_COMMENT",
    // vendor_checkpoint_id: "string",
    support_id: getValue(mainParams, `id`, ""),
  });
  const handleComments = (e: any) => {
    if (e) {
      const { name, value } = e.target;
      setCommentRequest({
        ...commentRequest,
        [name]: sanitizeInput(value),
      });
    } else {
      setCommentRequest({
        ...commentRequest,
        comments: "",
      });
      setEditId("");
    }
  };
  const [submitCommentLoading, setSubmitCommentLoading] = useState(false);
  const handleSubmitComment = async () => {
    try {
      setSubmitCommentLoading(true);
      let payload = commentRequest;
      if (editId) {
        const resp = await updateTaskComments(editId, payload);
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          setSubmitCommentLoading(false);
          setCommentRequest({
            ...commentRequest,
            comments: "",
          });
          setEditId("");
          getComments();
        } else {
          setSubmitCommentLoading(false);
        }
      } else {
        const resp = await addTaskComments(payload);
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          setSubmitCommentLoading(false);
          setCommentRequest({
            ...commentRequest,
            comments: "",
          });
          getComments();
        } else {
          setSubmitCommentLoading(false);
        }
      }
    } catch (error) {
      setSubmitCommentLoading(false);
    }
  };

  const [editId, setEditId] = useState("");
  const handleEditComments = (id: string, comments: string) => {
    setEditId(id);
    setCommentRequest({
      ...commentRequest,
      comments: comments,
    });
  };

  const [deleteOpen, setDeleteOpen] = useState(false);
  const handleDeleteOpen = () => {
    setDeleteOpen(!deleteOpen);
  };

  const handleDelete = (id: string, value: string) => {
    setDeleteId(id);
    setDeleteValue(value);
    handleDeleteOpen();
  };
  const [deleteId, setDeleteId] = useState("");
  const [deleteValue, setDeleteValue] = useState("");
  const handleDeleteComments = async () => {
    try {
      let resp = await deleteTaskComments(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDeleteOpen();
        setDeleteId("");
        setDeleteValue("");
        getComments();
      }
    } catch (error) {}
  };
  // ----------------- Upload section ----------------- //
  const [uploadedDocuments, setUploadedDocuments] = useState<any>([]);
  const [uploadLoading, setUploadLoading] = useState(false);
  const handleUploadDocuments = async (e: any) => {
    e.preventDefault();
    const files = Array.from(e.target.files);

    setUploadLoading(true);

    try {
      for (const item of files) {
        const formData = new FormData();
        formData.append("file", item as any);

        try {
          const resp = await clientFileUploads(formData); // waits for each file

          if (resp) {
            uploadedDocuments.push(getValue(resp, `data`, {}));
            setUploadedDocuments([...uploadedDocuments]);
          }
        } catch (error) {
          console.error("Upload error:", error);
        }
      }
    } finally {
      e.target.value = null;
      setUploadLoading(false);
    }
  };

  const handleDrop = (e: any) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    files.forEach(async (item: any) => {
      let formData = new FormData();
      formData.append("file", item);
      try {
        setUploadLoading(true);
        let resp = await clientFileUploads(formData);
        if (resp) {
          uploadedDocuments.push(getValue(resp, `data`, {}));
          setUploadedDocuments([...uploadedDocuments]);
          e.target.value = null;
          setUploadLoading(false);
        } else {
          e.target.value = null;
        }
      } catch (error) {
        e.target.value = null;
        setUploadLoading(false);
      }
    });
  };
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };
  const disableUpload = () => {};

  const [uploadSubmit, setUploadSubmit] = useState(false);
  const handleSubmitUpload = async () => {
    try {
      let payload =
        getValue(uploadedDocuments, `length`, 0) > 0
          ? uploadedDocuments.map((item: any) => item.id)
          : [];
      let resp = await uploadSupportTicket(mainParams.id, {
        document_ids: payload,
      });
      setUploadSubmit(true);
      if (resp) {
        setUploadSubmit(false);
        toast.success(getValue(resp, `message`, ""));
        getData();
      } else {
        setUploadSubmit(false);
      }
    } catch (error) {
      setUploadSubmit(false);
    }
  };
  const [deleteOpenDocument, setDeleteOpenDocument] = useState(false);
  const handleDeleteOpenDocument = () => {
    setDeleteOpenDocument(!deleteOpenDocument);
  };
  const handleDeleteDocument = (id: string, value: object) => {
    if (getValue(value, `createdAt`, "")) {
      handleRemoveUploadedFiles(id, value);
    } else {
      setDeleteDocumentId(id);
      setDeleteDocumentValue(value);
      handleDeleteOpenDocument();
    }
  };
  const [deleteDocumentId, setDeleteDocumentId] = useState("");
  const [deleteDocumentValue, setDeleteDocumentValue] = useState({});
  const handleRemoveUploadedFiles = async (id: string, item: object) => {
    if (getValue(item, `createdAt`, "")) {
      let filtered = uploadedDocuments.filter(
        (item: object) => getValue(item, `id`, "") !== id
      );
      setUploadedDocuments(filtered);
    } else {
      try {
        let resp = await deleteSupportTicket(mainParams.id, id);
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          getData();
        }
      } catch (error) {}
    }
  };

  const handleRemovedFiles = async () => {
    if (getValue(deleteDocumentValue, `createdAt`, "")) {
      let filtered = uploadedDocuments.filter(
        (item: object) => getValue(item, `id`, "") !== deleteDocumentId
      );
      setUploadedDocuments(filtered);
    } else {
      try {
        let resp = await deleteSupportTicket(mainParams.id, deleteDocumentId);
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          handleDeleteOpenDocument();
          getData();
        }
      } catch (error) {}
    }
  };
  const location = useLocation();
  const getPermissionsRoutes = () => {
    let route = location.pathname.split("/")[2];
    switch (route) {
      case "open":
        return "support_support_open";
      case "inprogress":
        return "support_support_in_progress";
      case "closed":
        return "support_support_closed";
      default:
        return null;
    }
  };
  return (
    <>
      <Header />
      {!isLoading &&
      (!getValue(props, `subTabPermissionList`, []).includes(
        getPermissionsRoutes()
      ) ||
        accessError === `You don't have access to perform this action`) ? (
        <NoAccessPage />
      ) : (
        <>
          <div className="support-details-main-wrapper">
            <div className="user-details-wrapper support-details-navigation-wrapper">
              <div className="user-details-wrapper__header  user-details-wrapper__header--new-header d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <NavLink
                    to={`/support/${location.pathname.split("/")[2]}`}
                    className="user-details-wrapper__header-back-link"
                  >
                    <img
                      src="/images/back-link.svg"
                      className="img-fluid my-2"
                    />
                  </NavLink>
                  <h6 className="mx-3 user-details-wrapper__header-title">
                    Open Ticket
                  </h6>
                </div>
                <div className="user-details-wrapper__cta-btns">
                  <button className="user-details-wrapper__cta-btn user-details-wrapper__cta-btn--primary">
                    Cancel
                  </button>
                  {getValue(props, `permissions`, []).includes("update") && (
                    <button
                      className="user-details-wrapper__cta-btn user-details-wrapper__cta-btn--secondary"
                      disabled={submitLoading}
                      onClick={handleSubmit}
                    >
                      {submitLoading ? "Please wait..." : "Submit"}
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="d-flex">
              <div className="open-ticket-wrapper d-flex w-100">
                <div className="module-wrapper">
                  <div className="module-card-holder">
                    <div className="module-wrapper__form-group form-group">
                      <label className="status-details-wrapper__label">
                        Ticket Status
                      </label>
                      {/* <select className="status-details-wrapper__select">
                <option className="green-color">Completed</option>
              </select> */}
                      <InputField
                        inputType="INPUT_REACT_SELECT"
                        name="support_status"
                        placeholder="Enter Ticket Status"
                        options={supportStatus}
                        onChange={(e: any) =>
                          handleChangeSelect(e, "support_status")
                        }
                        value={supportStatus.filter(
                          (item: any) =>
                            getValue(request, `support_status`, "") ===
                            getValue(item, `value`, "")
                        )}
                        validator={simpleValidator}
                        label={"support_status"}
                      />
                    </div>
                    <div className="module-wrapper__form-group form-group">
                      <label className="status-details-wrapper__label">
                        Module *
                      </label>
                      {/* <label className="module-wrapper__label"></label> */}
                      {/* <select className="module-wrapper__select">
              <option>Reports</option>
            </select> */}

                      <InputField
                        inputType="INPUT_REACT_SELECT"
                        name="module"
                        placeholder="Enter Module"
                        options={module}
                        onChange={(e: any) => handleChangeSelect(e, "module")}
                        value={module.filter(
                          (item: any) =>
                            getValue(request, `module`, "") ===
                            getValue(item, `value`, "")
                        )}
                        validator={simpleValidator}
                        label={"Module"}
                      />
                    </div>
                    <div className="module-wrapper__form-group form-group">
                      <label className="status-details-wrapper__label">
                        Severity *
                      </label>
                      {/* <select className="module-wrapper__select">
              <option>High</option>
            </select> */}
                      <InputField
                        inputType="INPUT_REACT_SELECT"
                        name="severity"
                        placeholder="Enter Severity"
                        options={severity}
                        onChange={(e: any) => handleChangeSelect(e, "severity")}
                        value={severity.filter(
                          (item: any) =>
                            getValue(request, `severity`, "") ===
                            getValue(item, `value`, "")
                        )}
                        validator={simpleValidator}
                        label={"Severity"}
                      />
                    </div>

                    <div className="module-wrapper__form-group form-group w-100">
                      <label className="status-details-wrapper__label">
                        Ticket Title *
                      </label>
                      {/* <div className="module-wrapper__text-details"> */}
                      {/* <p className="module-wrapper__text">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry’s standard dummy
                text ever since the 1500s
              </p> */}
                      <InputField
                        inputType="TEXTAREA"
                        name="ticket_title"
                        placeholder="Enter Ticket Title"
                        onChange={(e: any) => handleChangeRequest(e)}
                        value={getValue(request, `ticket_title`, "")}
                        validator={simpleValidator}
                        label={"Ticket Title"}
                      />
                      {/* </div> */}
                    </div>
                    <div className="module-wrapper__form-group form-group w-100">
                      <label className="status-details-wrapper__label">
                        Description *
                      </label>
                      {/* <div className="module-wrapper__text-details">
              <p className="module-wrapper__text">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry’s standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged.
              </p>
            </div> */}
                      <InputField
                        inputType="TEXTAREA"
                        name="description"
                        placeholder="Enter Description"
                        onChange={(e: any) => handleChangeRequest(e)}
                        value={getValue(request, `description`, "")}
                        validator={simpleValidator}
                        label={"Description"}
                      />
                    </div>
                  </div>
                </div>

                <div className="status-details-wrapper">
                  <div className="status-details-card-holder">
                    <div className="status-details-wrapper__form-group form-group">
                      <label className="status-details-wrapper__label">
                        Ticket Number
                      </label>
                      <input
                        type="text"
                        placeholder={getValue(info, `ticket_number`, "")}
                        className="status-details-wrapper__form-control form-control"
                        value={getValue(info, `ticket_number`, "")}
                        disabled
                      />
                    </div>

                    <div className="status-details-wrapper__form-group form-group">
                      <label className="status-details-wrapper__label">
                        Created by
                      </label>
                      <input
                        type="text"
                        placeholder={
                          getValue(info, `created_by.first_name`, "") +
                          " " +
                          getValue(info, `created_by.last_name`, "")
                        }
                        className="status-details-wrapper__form-control form-control"
                        disabled
                      />
                      <input
                        type="text"
                        placeholder={getValue(info, `created_by.email`, "")}
                        value={getValue(info, `created_by.email`, "")}
                        className="status-details-wrapper__form-control form-control mt-1"
                        disabled
                      />
                    </div>
                    <div className="status-details-wrapper__form-group form-group">
                      <label className="status-details-wrapper__label">
                        Created On
                      </label>
                      <input
                        type="text"
                        placeholder={convertCurrentDateWithTime(
                          getValue(info, `created_at`, "")
                        )}
                        className="status-details-wrapper__form-control form-control"
                        disabled
                      />
                    </div>
                    {/* <div className="status-details-wrapper__form-group form-group">
            <label className="status-details-wrapper__label">
              Upload Valid Doc/Screenshots Here
            </label>
            <div className="upload-wrapper">
              <div className="upload-wrapper__header d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <button className="attach-btn">Attach Files</button>
                  <h6 className="upload-wrapper__header-text">
                    Files Uploaded (25)
                  </h6>
                </div>
                <div className="d-flex align-items-center">
                  <img
                    src="/images/search.svg"
                    height={20}
                    width={20}
                    className="img-fluid mx-3"
                  />
                  <img
                    src="/images/search.svg"
                    height={20}
                    width={20}
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <img
                  src="/images/support/before.svg"
                  className="img-fluid cursor-pointer"
                />
                <div className="billing-data">
                  <div className="billing-data__header d-flex justify-content-between">
                    <img
                      src="/images/support/attach-files.svg"
                      className="img-fluid cursor-pointer"
                    />
                    <img
                      src="/images/close-black.svg"
                      className="img-fluid cursor-pointer"
                    />
                  </div>
                  <p className="billing-text">
                    Billing data_Accenture India Private Limited_12032021_120621
                  </p>
                </div>
                <img
                  src="/images/support/after.svg"
                  className="img-fluid cursor-pointer"
                />
              </div>
            </div>
          </div> */}
                    <CustomFileUpload
                      handleDrop={handleDrop}
                      uploadLoading={uploadLoading}
                      disableUpload={disableUpload}
                      permissions={["update"]}
                      handleDragOver={handleDragOver}
                      handleUploadDocuments={handleUploadDocuments}
                    />

                    {getValue(uploadedDocuments, `length`, 0) > 0
                      ? uploadedDocuments.map((item: object, key: number) => {
                          return (
                            <div
                              key={key}
                              className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between"
                            >
                              <p
                                className="cursor-pointer"
                                onClick={() =>
                                  handleDownloadOnClick(
                                    getValue(item, `url`, ""),
                                    getValue(item, `name`, "")
                                  )
                                }
                              >
                                {getValue(item, `name.length`, "") > 30
                                  ? getValue(item, `name`, "")
                                      .substring(0, 30)
                                      .concat("...")
                                  : getValue(item, `name`, "")}
                              </p>
                              {/* {getValue(props, `permissions`, []).includes("update") && ( */}
                              <img
                                src="/images/close-black.svg"
                                className="img-fluid cursor-pointer"
                                onClick={() =>
                                  handleDeleteDocument(
                                    getValue(item, `id`, ""),
                                    item
                                  )
                                }
                              />
                              {/* )} */}
                            </div>
                          );
                        })
                      : ""}
                    {getValue(uploadedDocuments, `length`, 0) > 0 ? (
                      <button
                        className="user-details-wrapper__cta-btn user-details-wrapper__cta-btn--secondary mb-4"
                        style={{ float: "right" }}
                        onClick={handleSubmitUpload}
                        disabled={uploadSubmit}
                      >
                        {uploadSubmit ? "Please wait..." : "Upload"}
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            {getValue(mainParams, `id`, "") ? (
              <>
                <div className="comments-wrapper">
                  <div className="comments-wrapper__header">
                    <h6>Comments</h6>
                  </div>
                  <Comments
                    request={commentRequest}
                    handleChange={handleComments}
                    handleSubmit={handleSubmitComment}
                    isLoading={submitCommentLoading}
                    editId={editId}
                    permissions={getValue(props, `permissions`, [])}
                  />
                  <OldComments
                    data={allComments}
                    isLoading={commentLoading}
                    handleEditComments={handleEditComments}
                    handleDelete={handleDelete}
                    permissions={getValue(props, `permissions`, [])}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <img
                    src="/images/profile-illustration.svg"
                    className="img-fluid"
                  />
                  <div>
                    <img
                      src="/images/cloud-illustration.png"
                      className="img-fluid"
                    />
                    <img
                      src="/images/profile-illustration.svg"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </>
            ) : null}
            <DeleteModal
              isOpen={deleteOpen}
              handleModal={handleDeleteOpen}
              handleSubmit={handleDeleteComments}
              deleteValue={deleteValue}
            />
            <DeleteModal
              isOpen={deleteOpenDocument}
              handleModal={handleDeleteOpenDocument}
              handleSubmit={handleRemovedFiles}
              deleteValue={getValue(deleteDocumentValue, `name`, "")}
            />
          </div>
        </>
      )}
    </>
  );
}
